import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidGroupedAssignee",
  "use": "SolidGroupedAssignee-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidGroupedAssignee\"><path d=\"M12 3a8 8 0 0 1 8 8v2a8 8 0 1 1-16 0v-2a8 8 0 0 1 8-8zm1 10.975h1.838A3.001 3.001 0 0 1 9 13v-2a3 3 0 0 1 5.624-1.455 1 1 0 1 0 1.748-.972A5 5 0 0 0 7 11v2a5 5 0 0 0 10 0v-.025a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol